<template>
    
  <div>

    <page-padding>
      <spinner v-if="showLoader"/>
      <div v-if="!showLoader && !hasItems">{{$t('language.no_pushnotifications')}}</div>
    </page-padding>

   <infinite-list v-if="hasItems" :list="pushnotes">

        <template v-slot:default="pushnote">
          <button-pushnote :item="pushnote.item"></button-pushnote>
      </template>
    </infinite-list>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import ButtonPushnote from './ButtonPushnote.vue';
import Spinner from '../../components/Spinner';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-pushnotes',
  props:{
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonPushnote,
    Spinner,
  },
  methods:{
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_pushnotes(){
     this.emitLoadStart();

      this.$store.dispatch('get_push_notes',{}).then(()=>{
        this.emitLoadEnd();
      })
    }
  },
  computed:{
    ...mapState([
       'pushnotes',
       ]),
       hasItems:function(){
         if(this.pushnotes){
           return this.pushnotes? this.pushnotes.length : false;
         }else{
           return false;
         }
       }
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_pushnotes)
    },
  created:function(){
    eventBus.$on("RELOAD_FROM_PULL",this.load_pushnotes)
    this.load_pushnotes();
    
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

